(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2040],{

/***/ 19002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/snippets/poshmark-offer-to-likers/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-07-11",
      tag: "Poshmark Snippets",
      title: "Everything about Poshmark\u2019s Offers to Likers",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Master offers to likers in Poshmark to boost your sales!"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Send an Offer to Likers"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your listing that you wish to send an offer out on"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Offer / Price Drop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Offer to Likers"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter Your Offer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select a Shipping Discount"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Hit Submit"
        })]
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: " What are the requirements for an offer to be recieved?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "A seller discount must be included"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The offer must be at least 10% below the the lowest offer the potential buyer has received in the past 90 days"
        })]
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: " Important Notes about Offers to Likers!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Counter offers by the potential buyer will not include a shipping discount"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers with no response or action expire after 24 hours"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Sellers cannot make a single item bundle with the same listing and send it to the potential buyer, regardless of discount offered"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers sent out go to all likers who have liked the listing as long as the offer is at least 10% below the lowest offer in the past 90 days"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers can be countered by the potential buyer"
        })]
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: " Best of luck, and happy selling!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-offer-to-likers.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Everything about Offers to Likers | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Master offers to likers in Poshmark to boost your sales!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-offer-to-likers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-offer-to-likers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Everything about Offers to Likers | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Master offers to likers in Poshmark to boost your sales!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-07-11T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-07-11T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 14494:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-offer-to-likers",
      function () {
        return __webpack_require__(19002);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(14494); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);